import type { CustomerTag, Lang } from '../data/types';
import { t } from '../i18n/t';
import { TAG } from './helpers';

interface TagsProps {
  tags: CustomerTag[];
  lang: Lang;
  /** Cap to N chips, e.g. `max={1}` in dense rows. */
  max?: number;
}

/** Tag chips for VIP / Regular / Allergy markers. */
export function Tags({ tags, lang, max }: TagsProps) {
  const list = (tags ?? []).filter((x) => TAG[x]);
  const sliced = max ? list.slice(0, max) : list;
  return (
    <>
      {sliced.map((x) => (
        <span key={x} className={`chip ${TAG[x].cls}`}>
          {t(TAG[x].key, lang)}
        </span>
      ))}
    </>
  );
}
